import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Caption } from '../../../../../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/TopDestinations/components/Item/components/Card/components/Caption.js';
import { Container } from '../../../../../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/TopDestinations/components/Item/components/Card/components/Container.js';
export const Card = ({
  caption,
  image,
  ...restProps
}) => {
  return _jsx(Container, {
    ...restProps,
    style:
    // @ts-expect-error ...
    {
      '--image-url': `url('${image}')`
    },
    children: _jsx(Caption, {
      children: caption
    })
  });
};